/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataCompletionResponse } from '../../models/data-completion-response';

export interface GetData$Params {
  manufacturer?: string;
  model?: string;
}

export function getData(http: HttpClient, rootUrl: string, params?: GetData$Params, context?: HttpContext): Observable<StrictHttpResponse<DataCompletionResponse>> {
  const rb = new RequestBuilder(rootUrl, getData.PATH, 'get');
  if (params) {
    rb.query('manufacturer', params.manufacturer, {});
    rb.query('model', params.model, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataCompletionResponse>;
    })
  );
}

getData.PATH = '/api/data-completion';
